import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createEventUsersSchemas } from 'shared/db/validation/schema/eventUsers';
import { Validator } from 'shared/db/validation/validator';
import {
    EventUserRawRecord,
    EventUserUpdateRawRecord,
} from 'shared/types/EventUser';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { EventUserDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createEventUsersSchemas();

const addValidator = createDBEntityValidator<EventUserRawRecord>(schemas.add);
const updateValidator = createDBEntityValidator<EventUserUpdateRawRecord>(
    schemas.update,
);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-event-users'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createEventUsersInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const eventUsersInputValidation: EventUserDBValidation = {
    add: createEventUsersInputValidation(addValidator, validationStrategy),
    update: createEventUsersInputValidation(
        updateValidator,
        validationStrategy,
    ),
    delete: createEventUsersInputValidation(
        deleteValidator,
        validationStrategy,
    ),
};
